import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, CalendarDays, ClipboardList, Euro, Settings as SettingsIcon, Plus, Camera, Package, Globe, FileSignature } from "lucide-react";
import { Button } from "@/components/ui/button";

const NAV = [
  { to: "/", label: "Tableau de bord", icon: LayoutDashboard, end: true, testid: "nav-dashboard" },
  { to: "/agenda", label: "Agenda", icon: CalendarDays, testid: "nav-agenda" },
  { to: "/reservations", label: "Réservations", icon: ClipboardList, testid: "nav-reservations" },
  { to: "/contrats", label: "Contrats", icon: FileSignature, testid: "nav-contrats" },
  { to: "/ca", label: "Chiffre d'affaires", icon: Euro, testid: "nav-revenue" },
  { to: "/stock", label: "Stock", icon: Package, testid: "nav-stock" },
  { to: "/demandes", label: "Demandes web", icon: Globe, testid: "nav-demandes" },
  { to: "/parametres", label: "Paramètres", icon: SettingsIcon, testid: "nav-settings" },
];

export default function Layout() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      {/* Sidebar desktop */}
      <aside className="hidden lg:flex fixed inset-y-0 left-0 w-64 flex-col bg-slate-900 text-white p-5 z-40">
        <div className="flex items-center gap-3 mb-8">
          <div className="h-10 w-10 rounded-xl bg-sky-500 flex items-center justify-center">
            <Camera className="h-5 w-5 text-white" />
          </div>
          <div>
            <p className="font-heading font-extrabold text-lg tracking-tight leading-none">Photobooth54</p>
            <p className="text-xs text-slate-400 mt-1">Lesménils · Nancy · Metz</p>
          </div>
        </div>
        <Button
          data-testid="btn-new-booking-sidebar"
          onClick={() => navigate("/reservations/nouvelle")}
          className="mb-6 bg-sky-500 hover:bg-sky-600 text-white font-semibold transition-colors"
        >
          <Plus className="h-4 w-4 mr-2" /> Nouvelle réservation
        </Button>
        <nav className="flex flex-col gap-1">
          {NAV.map(({ to, label, icon: Icon, end, testid }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={testid}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors ${
                  isActive ? "bg-white/10 text-white" : "text-slate-400 hover:text-white hover:bg-white/5"
                }`
              }
            >
              <Icon className="h-4 w-4" /> {label}
            </NavLink>
          ))}
        </nav>
      </aside>

      {/* Header mobile */}
      <header className="lg:hidden sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-slate-200 px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-lg bg-sky-500 flex items-center justify-center">
            <Camera className="h-4 w-4 text-white" />
          </div>
          <span className="font-heading font-extrabold tracking-tight">Photobooth54</span>
        </div>
        <Button
          size="sm"
          data-testid="btn-new-booking-top"
          onClick={() => navigate("/reservations/nouvelle")}
          className="bg-sky-500 hover:bg-sky-600 text-white font-semibold transition-colors"
        >
          <Plus className="h-4 w-4 mr-1" /> Réservation
        </Button>
      </header>

      <div className="lg:pl-64 pb-40 lg:pb-8">
        <main className="p-4 sm:p-6 lg:p-8 max-w-6xl mx-auto">
          <Outlet />
        </main>
      </div>

      {/* Bottom nav mobile */}
      <nav className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-slate-200 grid grid-cols-7">
        {NAV.map(({ to, label, icon: Icon, end, testid }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={`${testid}-mobile`}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 py-2.5 text-[10px] font-medium transition-colors ${
                isActive ? "text-sky-600" : "text-slate-500"
              }`
            }
          >
            <Icon className="h-5 w-5" />
            <span className="leading-none">{label.split(" ")[0] === "Chiffre" ? "CA" : label.split(" ")[0]}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
